import { z } from 'zod'

const ProviderAffiliationSchema = z.object({
  id: z.number(),
  name: z.string(),
  logo: z.string().nullable(),
})

// Main provider application schema
export const MarketplaceProviderSchema = z.object({
  status: z.number(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().email(),
  username: z.string().email(),
  name: z.string(),
  organization_description: z.string().nullable(),
  logo: z.string().nullable(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  global_state_id: z.number().nullable(),
  global_state_name: z.string().nullable(),
  zipcode: z.string().nullable(),
  customer_service_email: z.string().nullable(),
  customer_service_phone: z.string().nullable(),
  payments_support_email: z.string().nullable(),
  payments_support_phone: z.string().nullable(),
  mailing_address_different: z.nullable(z.union([z.string(), z.number()])),
  mailing_name: z.string().nullable(),
  mailing_email: z.string().nullable(),
  mailing_address: z.string().nullable(),
  mailing_city: z.string().nullable(),
  mailing_global_state_id: z.number().nullable(),
  mailing_global_state_name: z.string().nullable(),
  mailing_zip_code: z.string().nullable(),
  allow_in_store_pickup: z.number(),
  meta_data_tags: z.array(z.string()).nullable(),
  accepting_new_clients: z.number(),
  header_background_color: z.string().nullable(),
  website: z.string().nullable(),
  marketplace: z.number(),
  global_application_status_id: z.number(),
  global_business_category_id: z.number().nullable(),
  global_business_category_name: z.string(),
  global_business_type_id: z.number().nullable(),
  global_business_type_name: z.string(),
  global_business_filing_structure_id: z.number().nullable(),
  global_business_filing_structure_name: z.string(),
  applicant_first_name: z.string().nullable(),
  applicant_last_name: z.string().nullable(),
  applicant_phone_number: z.string().nullable(),
  fpc_first_name: z.string().nullable(),
  fpc_last_name: z.string().nullable(),
  phone_store: z.string().nullable(),
  fpc_email: z.string().nullable(),
  fpc_phone_number: z.string().nullable(),
  provider_category_other_description: z.string().nullable(),
  service_offered_other_description: z.string().nullable(),
  languages_supported_other_description: z.string().nullable(),
  multiple_locations: z.number().nullable(),
  service_locations: z.number().nullable(),
  provider_child_participating_ufa: z.nullable(
    z.union([z.string(), z.number()])
  ),
  already_registered_on_classwallet: z.nullable(
    z.union([z.string(), z.number()])
  ),
  comunication_consent: z.number().nullable(),
  attestation: z.number().nullable(),
  application_review: z.string().nullable(),
  send_me_copy_of_responses: z.number().nullable(),
  email_copy_of_responses: z.string().nullable(),
  delivery_methods: z.array(z.string()),
  provider_services: z.array(z.string()),
  languages: z.array(z.string()),
  provider_categories: z.array(z.string()),
  affiliations: z.array(ProviderAffiliationSchema).default([]),
})

export type MarketplaceProvider = z.infer<typeof MarketplaceProviderSchema>
